__turbopack_context__.v({
  "control": "pagination-module__zWJHsW__control",
});
